import React, { RefObject } from 'react';

export default function HorizontalScroll({
  children,
  scrollRef
}: {
  children: React.ReactNode;
  scrollRef?: RefObject<HTMLDivElement>;
}) {
  return (
    <div className="w-full overscroll-x-contain overscroll-y-none">
      <div
        ref={scrollRef}
        className="
        flex
        overflow-x-auto
        overflow-y-hidden
        scroll-smooth
        scrollbar-hide
        [webkit-overflow-scrolling:touch]
        w-full
        [-ms-overflow-style:none]
        [webkit-box-orient:vertical]
        [webkit-box-direction:normal]
      "
      >
        {children}
      </div>
    </div>
  );
}
